export default class DynamicVideoWithTextOverlay {
  constructor(section) {
    this.el = section.el;
    this.el.querySelector('[data-play-video]').addEventListener('click', () => this.playVideo());
  }

  playVideo() {
    const overlay = this.el.querySelector('[data-video-overlay]');
    const video = this.el.querySelector('iframe');

    if (!video) { return; }

    // Get src of video, and replace with auto-play url
    const videoSrc = video.getAttribute('src');
    const delimiter = (videoSrc != null ? videoSrc.indexOf('?') : undefined) === -1 ? '?' : '&';
    const videoSrcNew = `${videoSrc}${delimiter}autoplay=1`;
    video.setAttribute('src', videoSrcNew);

    setTimeout(() => overlay.classList.add('overlay-inactive'), 100);
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    this.el.querySelector('[data-play-video]').removeEventListener('click', () => this.playVideo());
    if (this.video) {
      this.video.remove();
    }
  }
}
